import { AddressResponse } from "./AddressResponse";

export class addressCheckService {
    private authApiUrl: string | undefined;
    private addressApiUrl: string | undefined;
    private sessionApiUrl: string | undefined;
    private dupAddressApiUrl: string | undefined;
  
    constructor() {
      // this.authApiUrl = process.env.REACT_APP__UQUAL_AUTHAPI;
      // this.addressApiUrl = process.env.REACT_APP__ADDRESSAPI;
      // this.sessionApiUrl = process.env.REACT_APP_SESSIONAPI;
      // this.dupAddressApiUrl = process.env.REACT_APP__UQUAL_DUPADDRESSAPI;
      this.authApiUrl = process.env.REACT_APP__UQUAL_AUTHAPI;
      this.addressApiUrl = process.env.REACT_APP__ADDRESSAPI;
      this.sessionApiUrl = process.env.REACT_APP_SESSIONAPI;
      this.dupAddressApiUrl = process.env.REACT_APP__UQUAL_DUPADDRESSAPI;
    }
  
    getAddressSearch = async (token:string,AddressRequest:any): Promise<AddressResponse |any| null> => {
      const requestOptions = {
        method: 'POST',
        headers: {
          'accept': 'application/json',
          'Authorization': 'Bearer '+token,
          'Content-Type': 'application/json',
        },
        body: JSON.stringify(AddressRequest),
      };
  
      if (this.addressApiUrl) {
        try {
          const response = await fetch(this.addressApiUrl, requestOptions);
          if (!response.ok) {
            throw new Error(`Error: ${response.statusText}`);
          }
          const data = await response.json();
          return { data};
        } catch (error) {
          console.error('Failed to fetch session token:', error);
          return null;
        }
      } else {
        console.error('Session API URL is not defined.');
        return null;
      }
    };
  }
  